import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import { IconFile } from "commonComponents/utilities/IconFile/IconFile";

export interface IFileIconLinkResponse {
    fileExtension: string;
    fileName: string;
    downloadLink: string;
}

class FileIconLinkCell extends PureComponent<IGridCellRenderProps<IFileIconLinkResponse>> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return (
            // DEPRECATED - Avoid using title in future code
            // eslint-disable-next-line react/forbid-dom-props
            <a title={cellValue.fileName} href={cellValue.downloadLink} download>
                <IconFile size="small" fileType={cellValue.fileExtension} />
            </a>
        );
    }
}

export const columnFileIconLink: IClientGridColumn<IFileIconLinkResponse> = {
    columnType: GridColumnType.fileIconLink,
    Cell: FileIconLinkCell,
};
